<template>
    <Modal v-model="show"
        :width="70"
        :footer-hide="true"
        title="禁售区域设置"
        class-name="vertical-center-modal"
        @on-visible-change="onShowChange">
        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                <Form label-position="top"
                    class="small-form">

                    <Row :gutter="16">
                        <Col span="6">
                        <FormItem label="省份">
                            <Select v-model="form.provinceUuid"
                                filterable
                                @on-change="onProvinceChange">
                                <Option v-for="item in provinceOptions"
                                    :key="item.regionUuid"
                                    :value="item.regionUuid">{{ item.regionName }}</Option>
                            </Select>
                        </FormItem>
                        </Col>

                        <Col span="6">
                        <FormItem label="城市">
                            <Select v-model="form.cityUuid"
                                filterable
                                @on-change="onCityChange">
                                <Option v-for="item in cityOptions"
                                    :key="item.regionUuid"
                                    :value="item.regionUuid">{{ item.regionName }}</Option>
                            </Select>
                        </FormItem>
                        </Col>

                        <Col span="6">
                        <FormItem label="区域">
                            <Select v-model="form.distUuid"
                                filterable>
                                <Option v-for="item in distOptions"
                                    :key="item.regionUuid"
                                    :value="item.regionUuid">{{ item.regionName }}</Option>
                            </Select>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label=" ">
                            <Button type="primary"
                                @click="onAddBlock">添加</Button>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <Table ref="mainTable"
                    size="small"
                    :columns="mainTable.columns"
                    :data="blockDistList"
                    highlight-row
                    stripe
                    border />
                </Col>
            </Row>

        </Card>
    </Modal>

</template>

<script>

import {
    addDistributionStationBlockDist,
    getDistributionStationBlockDistList,
    removeDistributionStationBlockDist
} from '@/api/modules/system-management/distributionStation-management';

export default {
    name: 'DistributionStationBlockDist',
    data() {
        return {
            show: false,
            form: {
                provinceUuid: '',
                cityUuid: '',
                distUuid: ''
            },
            blockDistList: [],
            allRegionInfo: [],
            provinceOptions: [],
            cityOptions: [],
            distOptions: [],
            mainTable: {
                columns: [
                    { title: '省份', key: 'provinceName', align: 'center' },
                    { title: '城市', key: 'cityName', align: 'center' },
                    { title: '区域', key: 'distName', align: 'center' },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    style: {},
                                    on: {
                                        click: () => {
                                            this.onRemove(params.row);
                                        }
                                    }
                                }, '删除')]);
                        }
                    }
                ]
            }
        };
    },
    mounted() {
        // this.init();
    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal() {
            this.show = true;
        },
        init() {
            this.$showGlobalSpin();
            getDistributionStationBlockDistList().then(res => {
                this.$hideGlobalSpin();
                if (res.code === 0) {
                    this.blockDistList = res.data.blockDistList;
                    this.allRegionInfo = res.data.allRegionInfo;

                    this.provinceOptions = this.allRegionInfo.filter(r => r.regionType === 1);
                    this.cityOptions = [];
                    this.distOptions = [];
                }
            }).catch(() => {
                this.$hideGlobalSpin();
            });
        },
        onProvinceChange(provinceUuid) {
            this.form.distUuid = '';
            this.distOptions = [];

            this.form.cityUuid = '';
            this.cityOptions = this.allRegionInfo.filter(r => r.regionType === 2 && r.regionParentUuid === provinceUuid);
        },
        onCityChange(cityUuid) {
            this.form.distUuid = '';
            this.distOptions = this.allRegionInfo.filter(r => r.regionType === 3 && r.regionParentUuid === cityUuid);
        },
        onAddBlock() {
            if (this.form.distUuid === '') {
                this.$Modal.error({ title: '出错啦', content: '请先选择禁售区域' });
                return;
            }

            const submitData = {
                distUuid: this.form.distUuid
            };

            this.$showGlobalSpin();
            addDistributionStationBlockDist(submitData).then(res => {
                this.$hideGlobalSpin();
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '添加成功',
                        onOk: () => {
                            this.init();
                        }
                    });
                }
            }).catch(() => {
                this.$hideGlobalSpin();
            });
        },
        onRemove(row) {
            const submitData = {
                distUuid: row.distUuid
            };

            this.$showGlobalSpin();
            removeDistributionStationBlockDist(submitData).then(res => {
                this.$hideGlobalSpin();
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '删除成功',
                        onOk: () => {
                            this.init();
                        }
                    });
                }
            }).catch(() => {
                this.$hideGlobalSpin();
            });
        }
    }
};
</script>

<style scoped>
</style>
